"use strict";
exports.__esModule = true;
require('./menu-toggle.css');
exports.default = {
  "menuToggle": "pf-c-menu-toggle",
  "menuToggleControls": "pf-c-menu-toggle__controls",
  "menuToggleCount": "pf-c-menu-toggle__count",
  "menuToggleIcon": "pf-c-menu-toggle__icon",
  "menuToggleText": "pf-c-menu-toggle__text",
  "menuToggleToggleIcon": "pf-c-menu-toggle__toggle-icon",
  "modifiers": {
    "primary": "pf-m-primary",
    "plain": "pf-m-plain",
    "expanded": "pf-m-expanded",
    "fullHeight": "pf-m-full-height"
  }
};